import { Box, Card, CardContent, Typography } from '@mui/material'

const MyBox = (props: any) => <Box sx={{ textAlign: 'center' }}>{props.children}</Box>

interface CallInfo {
  count: number
  todayCount: number
}

interface Props {
  invoice?: CallInfo
  orderForm?: CallInfo
  general?: CallInfo
  template?: CallInfo
}

export default function UsageThisMonth({ invoice, orderForm, general, template }: Props) {
  return (
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', gap: 8, px: 5 }}>
        {invoice && (
          <MyBox>
            <Typography>請求書OCR</Typography>
            <Typography variant="h2">{invoice.count}</Typography>
            <Typography variant="body1" color="text.secondary">
              Today {invoice.todayCount}
            </Typography>
          </MyBox>
        )}
        {orderForm && (
          <MyBox>
            <Typography>注文書OCR</Typography>
            <Typography variant="h2">{orderForm.count}</Typography>
            <Typography variant="body1" color="text.secondary">
              Today {orderForm.todayCount}
            </Typography>
          </MyBox>
        )}
        {template && (
          <MyBox>
            <Typography>Template OCR</Typography>
            <Typography variant="h2">{template.count}</Typography>
            <Typography variant="body1" color="text.secondary">
              Today {template.todayCount}
            </Typography>
          </MyBox>
        )}
        {general && (
          <MyBox>
            <Typography>テキスト・表</Typography>
            <Typography variant="h2">{general.count}</Typography>
            <Typography variant="body1" color="text.secondary">
              Today {general.todayCount}
            </Typography>
          </MyBox>
        )}
      </CardContent>
    </Card>
  )
}
